import React, { useEffect, useState } from "react";
import LightDefaultProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import DarkDefaultProfileImg from "~/common/components/Images";

import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import { Trans, useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";

const CommentaryModal = ({
	commentaryModal,
	setCommentaryModal,
	investInfo,
	userForCommentary,
}) => {
	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();
	const { t } = useTranslation();
	const [totalScore, setTotalScore] = useState();
	const userSelected = investInfo?.Judge?.find((d) => d.userIdx === userForCommentary);

	useEffect(() => {
		setTotalScore(userSelected?.totalScore);
	}, [investInfo, userSelected]);

	return (
		<ModalTemplate
			modalState={commentaryModal}
			setModalToggle={setCommentaryModal}
			width={720}
			height={472}
			className="commentary-modal"
		>
			<div className="modal-content">
				<div className="judge-vc-wrap">
					<div className="row">
						<div className="img-wrap">
							<img
								src={
									userSelected?.VcUser?.img ||
									(theme === "dark"
										? DarkDefaultProfileImg
										: LightDefaultProfileImg)
								}
								alt={t(
									"pages.investment.InvestEvalPage.detail.Step.modalForJudge.CommentaryModal.imageAlt"
								)}
							/>
						</div>
						<dl className="judging-vc">
							<dt>{userSelected?.VcUser?.UserProfile.name}</dt>
							<dd />
						</dl>
					</div>
					<div className="judging-vc-score">
						<Trans
							i18nKey="pages.investment.InvestEvalPage.detail.Step.modalForJudge.CommentaryModal.totalScore"
							components={[<b />, { totalScore: totalScore?.toFixed(2) }]}
						/>
					</div>
				</div>

				{investInfo?.Review?.Category.map((d) => (
					<div className="c__form vertical judge-detail-group" key={d.idx}>
						<div className="f__label">
							{d.title}
							<span>
								<Trans
									i18nKey="pages.investment.InvestEvalPage.detail.Step.modalForJudge.CommentaryModal.label01"
									components={[{ d }]}
								/>
							</span>
						</div>
						<div className="f__control">
							{d.Item.map((item) => {
								const itemScorePut = userSelected?.Score.find(
									(score) => score.itemIdx === item.idx
								);
								return (
									<div className="commentary-wrap" key={item.idx}>
										<div className="commentary">{item.content}</div>
										<div data-unit="/10" className="ratio">
											{itemScorePut?.score}
										</div>
									</div>
								);
							})}
						</div>
					</div>
				))}

				<div className="c__form vertical">
					<div className="f__group judge-commentary">
						<div className="f__label">
							{t(
								"pages.investment.InvestEvalPage.detail.Step.modalForJudge.CommentaryModal.label02"
							)}
						</div>
						<div className="f__control">
							<textarea
								className="c__textarea f__item"
								value={userSelected?.comment}
								readOnly
							/>
						</div>
					</div>
				</div>
			</div>
		</ModalTemplate>
	);
};

export default CommentaryModal;
